export default __webpack_public_path__ + "static/media/placeholder_instructions_dark.fb56c25b.svg";